import React, { useState } from 'react';
import styled from 'styled-components';

const ControlsContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-left: 16px;
  opacity: ${props => props.$alwaysVisible ? 1 : 0};
  transition: opacity 0.2s;
`;

const ControlButton = styled.button`
  background: rgba(42, 42, 42, 0.9);
  border: 1px solid #555;
  border-radius: 4px;
  color: #fff;
  padding: 6px 12px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    background: rgba(51, 51, 51, 0.9);
    border-color: #e50914;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

const EditButton = styled(ControlButton)`
  &:hover {
    background: rgba(37, 99, 235, 0.9);
    border-color: rgb(37, 99, 235);
  }
`;

const DeleteButton = styled(ControlButton)`
  &:hover {
    background: rgba(229, 9, 20, 0.9);
    border-color: #e50914;
  }
`;

const ArrowButton = styled(ControlButton)`
  padding: 6px 8px;

  &:hover {
    background: rgba(51, 51, 51, 0.9);
  }
`;

const SectionControls = ({
  onEdit,
  onDelete,
  onMoveUp,
  onMoveDown,
  canMoveUp,
  canMoveDown,
  alwaysVisible = false
}) => {
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);

  const handleDelete = () => {
    if (showConfirmDelete) {
      onDelete();
      setShowConfirmDelete(false);
    } else {
      setShowConfirmDelete(true);
      // Reset confirmation after 3 seconds
      setTimeout(() => setShowConfirmDelete(false), 3000);
    }
  };

  return (
    <ControlsContainer $alwaysVisible={alwaysVisible}>
      {onMoveUp && (
        <ArrowButton
          onClick={onMoveUp}
          disabled={!canMoveUp}
          title="Move section up"
          aria-label="Move section up"
        >
          <svg fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
        </ArrowButton>
      )}

      {onMoveDown && (
        <ArrowButton
          onClick={onMoveDown}
          disabled={!canMoveDown}
          title="Move section down"
          aria-label="Move section down"
        >
          <svg fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </ArrowButton>
      )}

      {onEdit && (
        <EditButton onClick={onEdit} title="Edit section" aria-label="Edit section">
          <svg fill="currentColor" viewBox="0 0 20 20">
            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
          </svg>
          Edit
        </EditButton>
      )}

      {onDelete && (
        <DeleteButton onClick={handleDelete} title={showConfirmDelete ? "Click again to confirm" : "Delete section"} aria-label="Delete section">
          <svg fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          {showConfirmDelete ? 'Confirm?' : 'Delete'}
        </DeleteButton>
      )}
    </ControlsContainer>
  );
};

export default SectionControls;
